interface TitleLimitPlatform {
  code: string;
  title: string;
  limit: number;
  isLimitVerified: boolean;
}

export interface TitleLimitChipData {
  key: string;
  label: string;
  limit: number;
}

/**
 * Chip row data for the title extension field: platforms with a verified limit get
 * their own chip (ascending by limit), platforms on the BE fallback envelope collapse
 * into one "others" chip per distinct envelope value, appended after the named ones.
 * No uniform-envelope assumption — should the BE ever serve two different fallback
 * values, two "others" chips render.
 */
export function buildTitleLimitChips(
  platforms: TitleLimitPlatform[],
  othersLabel: string
): TitleLimitChipData[] {
  const verified = platforms
    .filter((platform) => platform.isLimitVerified)
    .map((platform) => ({key: platform.code, label: platform.title, limit: platform.limit}))
    .sort((a, b) => a.limit - b.limit);

  const fallbackLimits = [
    ...new Set(
      platforms.filter((platform) => !platform.isLimitVerified).map((platform) => platform.limit)
    ),
  ]
    .sort((a, b) => a - b)
    .map((limit) => ({key: `others-${limit}`, label: othersLabel, limit}));

  return [...verified, ...fallbackLimits];
}
